import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientIPRule } from "../typeDefs/ipAddresses";
import { QueueMessage } from "../typeDefs/queueManagement";

export interface IpAddressState {
	loading: boolean;
	rules: ClientIPRule[];
	messages: QueueMessage[];
}

const initialState: IpAddressState = {
	loading: false,
	rules: [],
	messages: [],
};

export const ipAddressesSlice = createSlice({
	name: "ipAddresses",
	initialState,
	reducers: {
		setRules: (state, action: PayloadAction<ClientIPRule[]>) => {
			state.rules = action.payload;
		},
		setQueueMessages: (state, action: PayloadAction<QueueMessage[]>) => {
			state.messages = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setRules, setQueueMessages, setLoading } =
	ipAddressesSlice.actions;

export default ipAddressesSlice.reducer;
